export enum HelpFeedbackRating {
  like = "like",
  neutral = "neutral",
  dislike = "dislike",
}

export interface ApiHelpFeedback {
  id: number;
  article_id: string;
  rating: HelpFeedbackRating | null;
  comment: string | null;
  language: string;
  datetime_created_at: Date;
  datetime_updated_at: Date;
  datetime_comment_submitted_at: Date | null;
}

export interface ApiHelpFeedbackRatingSave {
  article_id: string;
  rating: HelpFeedbackRating;
  language: string;
}

export interface ApiHelpArticleViewSave {
  article_id: string;
  language: string;
}

export interface ApiHelpFeedbackCommentSave {
  article_id: string;
  comment: string;
  language: string;
}
